import type { TableFilterTreeOptions } from "../table-filter.type";
import type { ReferentialStateEndpoint } from "@/entities/referential/referential-states";

import { useReferentialStates } from "@/entities/referential/referential-states";

export const useTableFilterReferentialStates = (
  type: ReferentialStateEndpoint
): TableFilterTreeOptions => {
  const { states } = useReferentialStates(type);

  const filters = states.map((state) => ({
    text: state.name,
    value: state.value,
  }));

  return {
    filterMode: "tree",
    filters,
  };
};
